import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { cn } from '@core/utils';
import type { PolicyDetail } from '@/api/getPolicyDetail';
import { Image } from '@/components/client';
import DigitalServiceOpenImage from '../_assets/open.png';
import { AiSummary } from './AiSummary';
import { QuickApplyButton } from './QuickApplyButton';
import { ViewCount } from './ViewCount';
interface PolicyHeaderProps {
  data: PolicyDetail;
  policyIdIdx: string;
  className?: string;
}
export const PolicyHeader = t0 => {
  const $ = _c(53);
  const {
    data,
    policyIdIdx,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full flex-col items-center gap-12 px-24 mobile-tablet:px-16", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== data.id) {
    t2 = <ViewCount id={data.id} />;
    $[2] = data.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data.policyName) {
    t3 = <h1 className="w-full max-w-300 text-center font-600 text-Gray-900 typo-h6">{data.policyName}</h1>;
    $[4] = data.policyName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== data.dday) {
    t4 = data.dday ? <li><Badge className="text-R-400">{data.dday}</Badge></li> : null;
    $[6] = data.dday;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== data.provisionTypeList) {
    t5 = data.provisionTypeList?.map(_temp);
    $[8] = data.provisionTypeList;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== data.applyTypeList) {
    t6 = data.applyTypeList?.map(_temp2);
    $[10] = data.applyTypeList;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <ul className="flex flex-wrap items-center justify-center gap-4">{t4}{t5}{t6}</ul>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t7) {
    t8 = <div className="flex w-full max-w-[335px] flex-col items-center justify-center gap-16">{t3}{t7}</div>;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t8) {
    t9 = <div className="flex flex-col items-center gap-2">{t2}{t8}</div>;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex w-49 flex-col gap-20 text-center text-Gray-600"><dt>지원혜택</dt><dt>신청기간</dt><dt>정책기관</dt></div>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== data.supportBenefit) {
    t11 = <dd className="w-full text-left mobile-tablet:text-right">{data.supportBenefit}</dd>;
    $[23] = data.supportBenefit;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== data.dueDateBetween) {
    t12 = <dd className="w-full text-left mobile-tablet:text-right">{data.dueDateBetween}</dd>;
    $[25] = data.dueDateBetween;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== data.agency || $[28] !== data.agencyLogo) {
    t13 = data.agencyLogo ? <Image alt={data.agency || "\uC815\uCC45 \uAE30\uAD00 \uB85C\uACE0"} className="rounded-small border border-Gray-300 bg-Gray-white object-contain p-2" height={26} src={data.agencyLogo} width={26} /> : null;
    $[27] = data.agency;
    $[28] = data.agencyLogo;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== data.agency) {
    t14 = <span>{data.agency}</span>;
    $[30] = data.agency;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t13 || $[33] !== t14) {
    t15 = <dd className="flex items-center gap-6">{t13}{t14}</dd>;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t15) {
    t16 = <dl className="flex w-full gap-16 rounded-large bg-Gray-white px-16 py-20 font-400 tracking-[-0.28px] typo-body4">{t10}<div className="flex min-w-0 flex-1 flex-col items-start gap-20 text-Gray-900 mobile-tablet:items-end">{t11}{t12}{t15}</div></dl>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== data.aiSummaryList) {
    t17 = data.aiSummaryList ? <AiSummary aiSummaryList={data.aiSummaryList} /> : null;
    $[39] = data.aiSummaryList;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== policyIdIdx) {
    t18 = "10d028fd-26d3-4c96-b9fa-b1a91ebeea0d" === policyIdIdx ? <Image alt={"\uBCF8 \uCF58\uD150\uCE20\uB294 \uB514\uC9C0\uD138\uC11C\uBE44\uC2A4\uAC1C\uBC29\uACFC \uD568\uAED8\uD569\uB2C8\uB2E4."} height={23} src={DigitalServiceOpenImage} width={335} placeholder="blur" /> : null;
    $[41] = policyIdIdx;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== data.policyApplicationTypeCd || $[44] !== data.policyApplyId) {
    t19 = data.policyApplyId && data.policyApplicationTypeCd ? <QuickApplyButton policyApplicationType={data.policyApplicationTypeCd} policyApplyId={data.policyApplyId} /> : null;
    $[43] = data.policyApplicationTypeCd;
    $[44] = data.policyApplyId;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t1 || $[47] !== t16 || $[48] !== t17 || $[49] !== t18 || $[50] !== t19 || $[51] !== t9) {
    t20 = <header className={t1}>{t9}{t16}{t17}{t18}{t19}</header>;
    $[46] = t1;
    $[47] = t16;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
    $[51] = t9;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
};
function _temp(type, index) {
  return <li key={index}><Badge className="text-B-500">{type}</Badge></li>;
}
function _temp2(type_0, index_0) {
  return <li key={index_0}><Badge className="text-Gray-700">{type_0}</Badge></li>;
}